// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--2usBB","star_full":"a10a3f92e9--star_full--mZra5","star_empty":"a10a3f92e9--star_empty--1wRlk","star_half":"a10a3f92e9--star_half--1y7mG"};